import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PasswordModule } from 'primeng/password';

import { COMMON_STANDALONE_IMPORTS } from '@shared/common-imports';
import { FormErrorComponent, ImageFormControlComponent, LoaderComponent } from '@shared/components';
import { RequiredLabelDirective } from '@shared/directives';
import { AuthService, ToastsService } from '@shared/services';
import { FormGenerator, FormGroupExtension } from '@shared/utils';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ...COMMON_STANDALONE_IMPORTS,
    LoaderComponent,
    FormErrorComponent,
    ImageFormControlComponent,
    RequiredLabelDirective,
    PasswordModule,
  ],
})
export class RegisterComponent {
  registerComponentLoader = 'registerComponentLoader';
  editForm = FormGenerator.initRegisterCompanyForm(this.translate);
  trialBenefits = [
    {
      icon: 'pi pi-credit-card',
      title: 'auth.register.trialBenefitNoCreditCardTitle',
      description: 'auth.register.trialBenefitNoCreditCardDescription',
    },
    {
      icon: 'pi pi-headphones',
      title: 'auth.register.trialBenefitSupportTitle',
      description: 'auth.register.trialBenefitSupportDescription',
    },
    {
      icon: 'pi pi-comments',
      title: 'auth.register.trialBenefitFeedbackTitle',
      description: 'auth.register.trialBenefitFeedbackDescription',
    },
  ];

  constructor(
    private authService: AuthService,
    private toastsService: ToastsService,
    private translate: TranslateService
  ) {}

  onSubmit(): void {
    if (FormGroupExtension.hasAnyValidationError(this.editForm)) {
      FormGroupExtension.markFormAsDirtyAndTouched(this.editForm);
      this.toastsService.showError(
        FormGroupExtension.getFormValidationErrorsMessage(this.editForm, this.translate),
        this.translate.instant('error.invalidForm')
      );
      return;
    }

    this.authService.registerCompany(this.registerComponentLoader, this.editForm.getRawValue()).subscribe({
      next: () => this.toastsService.showSuccess(this.translate.instant('auth.register.trialStarted')),
      error: (error) => this.toastsService.showError(error),
    });
  }
}
